import React, { useContext } from 'react';
import styled from 'styled-components';
import { Text, Icon, Button, theme, Tooltip } from 'components';
import { AnsweringServiceType } from '@bb/domain/dist/types/AnsweringSubscription';
import { StyledIconWrapper } from '../../StyledComponents';
import ServiceLabels from '../../ServiceLabels';
import AppointmentDeskContext, {
  AppointmentDeskStep,
} from '../../AppointmentDeskContext';
import { APPOINTMENT_DESK_LABELS, HOW_IT_WORKS_TEXT } from '../../constants';

const AnsweringServiceInfo: React.FC = () => {
  const {
    portalConfig,
    setCurrentStep,
    setSelectedSubscriptionType,
    subscriptionExists,
  } = useContext(AppointmentDeskContext);

  if (!portalConfig) return null;

  const {
    answeringServiceName,
    brokeragePrice,
    agentPrice,
    appointmentDeskMlsPay,
    answeringServicePhone,
  } = portalConfig;

  return (
    <StyledMainContainer>
      <StyledIconWrapper>
        <Icon type="antdPhoneFilled" color="black" />
      </StyledIconWrapper>
      <StyledHeaderSection>
        <StyledHeaderText>Appointment Desk</StyledHeaderText>
        <StyledHeaderSubText type="secondary">
          Everything you need to manage your listings
        </StyledHeaderSubText>
      </StyledHeaderSection>
      <StyledPhoneNumberContainer>
        <StyledPhoneTextContainer>
          <StyledPhoneText type="secondary">
            Paste this on your listings
          </StyledPhoneText>
          <Tooltip title={HOW_IT_WORKS_TEXT}>
            <span>
              <Icon type="antdInfoCircleFilled" color="grey" />
            </span>
          </Tooltip>
        </StyledPhoneTextContainer>
        <StyledPhoneNumber>{answeringServicePhone}</StyledPhoneNumber>
      </StyledPhoneNumberContainer>
      <StyledServiceLabelContainer>
        <StyledServiceLabelText>Included</StyledServiceLabelText>
        <ServiceLabels labels={APPOINTMENT_DESK_LABELS} />
      </StyledServiceLabelContainer>
    </StyledMainContainer>
  );
};

export default AnsweringServiceInfo;

const StyledMainContainer = styled.div`
  padding: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 440px;
  min-height: 766px;
`;

const StyledHeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
`;

const StyledHeaderText = styled(Text)`
  font-size: 16px;
  font-weight: 400;
`;

const StyledHeaderSubText = styled(Text)``;

const StyledSetupButton = styled(Button)`
  width: 100%;
  font-weight: 400;
  align-self: flex-end;
`;

const StyledPhoneNumberContainer = styled.div`
  border: 1px solid ${theme.gray4};
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
`;

const StyledPhoneTextContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledPhoneText = styled(Text)`
  font-size: 12px;
  line-height: 20px;
  padding-right: 8px;
`;

const StyledPhoneNumber = styled(Text)`
  font-size: 20px;
  font-weight: 600;
`;

const StyledServiceLabelContainer = styled.div`
  flex-grow: 1;
`;

const StyledServiceLabelText = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
`;
